import styled from 'styled-components';

import MQ from '@rover/kibble/styles/MediaQuery';

const FilterWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space['6x']};

  ${MQ.XS_DOWN.toString()} {
    margin-bottom: ${({ theme }) => theme.space['4x']};
  }
`;

export default FilterWrapper;
